module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-footer",
    class: {
      'downpay': _vm.product.downPayment,
      'downPayOriginSoldOut': _vm.downpayOriginSoldOut
    }
  }, [(_vm.product.downPayment) ? _c('div', {
    staticClass: "downpay-footer",
    on: {
      "click": _vm.downpayAction
    }
  }, [_c('div', {
    staticClass: "downpay-desc"
  }, [(_vm.downpayPrice) ? _c('div', {
    staticClass: "desc-main"
  }, [_c('div', {
    staticClass: "downpay-label"
  }, [_vm._v("定金")]), _vm._v(" "), (_vm.downpayPrice.length > 1) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayPrice[0]
    }
  }), _vm._v(" "), (!_vm.product.downPayment.priceSingle) ? _c('span', [_vm._v(" - "), _c('price', {
    attrs: {
      "data": _vm.downpayPrice[1]
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayPrice[0]
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.downpayDeduction && _vm.product.downPayment.deductionFlag) ? _c('div', {
    staticClass: "desc-sub"
  }, [_vm._v("（ 可抵\n        "), (_vm.downpayDeduction.length > 1) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayDeduction[0]
    }
  }), _vm._v(" "), (!_vm.product.downPayment.deductionSingle) ? _c('span', [_vm._v(" - "), _c('price', {
    attrs: {
      "data": _vm.downpayDeduction[1]
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayDeduction[0]
    }
  })], 1), _vm._v(" ）\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arrow-text"
  }, [_vm._v("立即预订")]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "normal-footer"
  }, [_c('div', {
    staticClass: "minicart",
    on: {
      "click": _vm.toCart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "service",
    on: {
      "click": _vm.toService
    }
  }, [(_vm.msgCount > 0) ? _c('i') : _vm._e()]), _vm._v(" "), (_vm.product.isWechatGift && !_vm.product.offShelf && !_vm.product.soldOut) ? _c('div', {
    staticClass: "wechat-gift-box",
    on: {
      "click": _vm.showWechatGiftBox
    }
  }, [(_vm.gifUrl) ? _c('img', {
    attrs: {
      "id": "panda-gif",
      "src": _vm.gifUrl
    },
    on: {
      "load": _vm.gifLoaded
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.app && (_vm.product.id === 'PROD001032623' || _vm.product.id === 'PROD001032622')) ? _c('div', {
    staticClass: "action",
    class: _vm.no - _vm.buy
  }, [(_vm.ios) ? _c('a', {
    staticClass: "btn dark",
    attrs: {
      "href": _vm.iosAul
    },
    on: {
      "click": _vm.iosDownloadApp
    }
  }, [_vm._v("去APP购买")]) : _vm._e(), _vm._v(" "), (_vm.android) ? _c('div', {
    staticClass: "btn dark",
    on: {
      "click": _vm.androidDownloadApp
    }
  }, [_vm._v("去APP购买")]) : _vm._e()]) : (_vm.product.arrival && _vm.product.arrival.show) ? _c('div', {
    staticClass: "action booking"
  }, [(!_vm.product.arrival.subscribe && !_vm.booked) ? _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.bookProduct(_vm.product.id)
      }
    }
  }, [_c('p', [_vm._v("我也想买")]), _vm._v(" "), _c('p', {
    staticClass: "sm"
  }, [_vm._v("(补货后提醒我)")])])]) : _c('div', {}, [_vm._m(1), _vm._v(" "), _vm._m(2)])]) : (!_vm.product.soldOut && _vm.product.customPrintTemplate == 6) ? _c('div', {
    staticClass: "action",
    class: {
      'no-buy': _vm.unSale()
    }
  }, [_c('div', {
    staticClass: "btn btn-buy dark",
    on: {
      "click": _vm.tapBuyCustom
    }
  }, [_vm._v("立即定制")])]) : (!_vm.product.downPayment || (_vm.product.downPayment && !_vm.product.soldOut)) ? _c('div', {
    staticClass: "action",
    class: {
      'no-buy': _vm.unSale()
    }
  }, [(!_vm.product.prevue && !_vm.product.customizable) ? _c('div', {
    staticClass: "btn btn-buy",
    class: {
      'small-btn': _vm.product.isWechatGift
    },
    on: {
      "click": _vm.tapBuy
    }
  }, [_vm._v("立即购买")]) : _vm._e(), _vm._v(" "), (!_vm.product.customizable && !_vm.product.monthSend) ? _c('div', {
    staticClass: "btn btn-cart dark",
    class: {
      'small-btn': _vm.product.isWechatGift
    },
    on: {
      "click": _vm.tapCart
    }
  }, [_vm._v("加入购物车")]) : _vm._e(), _vm._v(" "), (_vm.product.customizable) ? _c('a', {
    staticClass: "btn dark",
    attrs: {
      "href": _vm.aul
    }
  }, [_vm._v("去APP购买")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "texts"
  }, [_c('p', [_vm._v("若想要人数较多,")]), _vm._v(" "), _c('p', [_vm._v("将有补货可能哦!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "texts"
  }, [_c('p', [_vm._v("若补货成功会优先短信提醒你!")]), _vm._v(" "), _c('p', [_vm._v("若未补货,将不再另行通知!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn"
  }, [_c('p', {
    staticClass: "booked"
  }, [_vm._v("已登记")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0eb117"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/footer.vue
// module id = 1044
// module chunks = 2